//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SEND_SUGGESTION } from "@/graphql/mutations/auth.js";
import EventBus from "@/event-bus.js";

export default {
  name: "ReportarSugerencia",
  async mounted() {
    EventBus.$emit("page-loaded", { page: "ReportarSugerencia" });
  },
  data() {
    return {
      valid: false,
      sugerencia: ""
    };
  },
  methods: {
    async submit() {
      let success = await this.$refs.form.validate();
      if (success) {
        console.log(`Enviando sugerencia`);
        this.$q.loading.show({
          message:
            "Enviando sugerencia o incidencia... <br/><span>Espere...</span>"
        });
        try {
          await this.$apollo.mutate({
            mutation: SEND_SUGGESTION,
            variables: {
              sugerencia: this.sugerencia
            }
          });
          this.$q.notify({
            position: "top-right",
            message: "Enviado correctamente",
            color: "positive"
          });
        } catch (e) {
          console.log(e.message);
          this.$q.notify({
            position: "top-right",
            message: e.message,
            color: "negative"
          });
        } finally {
          this.$q.loading.hide();
        }
      } else {
        console.error(`Modelo no correcto`);
      }
    }
  }
};
